import React from 'react';
import RepriceDialog from 'components/RepriceDialog';
import { useExecCtx } from 'shared/state/configContexts';
import { useQuoteActionsCtx } from 'shared/state/quoteActionsContext';

/** Hosts the untouched RepriceDialog. It brings its own focus trap and Escape
 *  handling (RepriceDialog.jsx:28-36), so it is not wrapped in the shared
 *  Dialog; the restyle rides with the rest of the classic look in a later
 *  phase. The basis panel is rebuilt from the exec session exactly as the
 *  classic shell built it (App.js:1605-1618). */
export function RepriceOverlay() {
  const { execPricing } = useExecCtx();
  const { repriceDiff, acceptReprice, setRepriceDiff, qtyByPartNumber } = useQuoteActionsCtx();
  if (!repriceDiff) return null;

  const { diff } = repriceDiff;
  return (
    <RepriceDialog
      diff={diff}
      qtyByPn={qtyByPartNumber}
      basis={{
        vendor: execPricing.snapshot?.vendor ?? null,
        quarter: execPricing.snapshot?.quarter ?? null,
        catalogIntegrationBp: execPricing.snapshot?.integrationBp ?? null,
        overrideIntegrationBp: execPricing.overrides?.integrationBp ?? null,
        customSkuCount: execPricing.customSkus?.size ?? 0,
        catalogSkuCount: Object.keys(execPricing.snapshot?.compositions ?? {}).length,
      }}
      onAccept={acceptReprice}
      onCancel={() => setRepriceDiff(null)}
    />
  );
}
